type Listener = () => void
type Unsubscribe = () => void

// biome-ignore lint/complexity/noBannedTypes: <explanation>
export class Subscribable<TListener extends Function = Listener> {
	protected listeners: Map<string, [TListener, Unsubscribe][]>

	constructor() {
		this.listeners = new Map()
	}

	subscribe(key: string, listener: TListener): () => void {
		const callback = listener || (() => undefined)

		const unsubscribe = () => {
			const listeners = this.listeners.get(key)

			if (!listeners) {
				return
			}

			const newListeners = listeners.filter(([x]) => x !== callback)

			if (newListeners.length) {
				this.listeners.set(key, newListeners)
			} else {
				this.listeners.delete(key)
			}

			this.onUnsubscribe()
		}

		if (this.listeners.has(key)) {
			this.listeners.get(key)?.push([listener, unsubscribe])
		} else {
			this.listeners.set(key, [[listener, unsubscribe]])
		}

		this.onSubscribe(key)

		return unsubscribe
	}

	protected publish(key: string, value: unknown) {
		const listeners = this.listeners.get(key)

		if (!listeners) {
			return
		}

		for (const [listener, unsubscribe] of listeners) {
			try {
				listener(value)
			} catch (_e) {
				console.error(`failed to invoke listener for key '${key}''`)
			}

			unsubscribe()
		}
	}

	protected onSubscribe(_key: string): void {
		//
	}

	protected onUnsubscribe(): void {
		// void
		// console.log(this.listeners)
	}
}
